const TerminosCondiciones = () => {
  return (
    <div className="container my-5">
      {/* HEADER */}
      <div className="terminos-header text-center mb-5">
        <span className="terminos-badge">Legal</span>
        <h1 className="terminos-title">Términos y Condiciones</h1>
        <p className="terminos-sub">
          Última actualización: <strong>05/02/2026</strong>
        </p>
      </div>

      {/* CARD PRINCIPAL */}
      <div className="card terminos-card border-0 shadow-lg">
        <div className="card-body p-4 p-md-5">

          {/* INTRO */}
          <p className="terminos-intro">
            El acceso, navegación y uso del sitio web{" "}
            <strong>https://marketluz.com</strong> (en adelante, “MarketLuz”)
            se rige por los presentes Términos y Condiciones, así como por la
            legislación vigente de la República del Perú.
          </p>

          <p>
            Al acceder, registrarse o realizar una compra en MarketLuz, el
            usuario acepta expresamente estos Términos y Condiciones.
            MarketLuz se reserva el derecho de modificarlos en cualquier
            momento, notificando a los usuarios por los medios
            correspondientes.
          </p>

          <div className="terminos-divider" />

          {/* SECCIONES */}

          <Section
            number="1"
            title="Información general del comercio"
            content={[
              "Razón Social: JOSE CARLOS ALANIA AGUERO",
              "RUC: 10098478545",
              "Dirección: Av los ingenieros 262 la molina",
              "Teléfono: 987 157 652",
              "Correo electrónico: admin@marketluz.com",
              "MarketLuz es una plataforma de comercio electrónico de intermediación que conecta vendedores independientes con compradores finales.",
              "MarketLuz no fabrica ni produce productos, salvo que se indique expresamente lo contrario."
            ]}
          />

          <Section
            number="2"
            title="Aceptación de los Términos y Condiciones"
            content={[
              "El uso de la plataforma implica la aceptación plena de los presentes Términos y Condiciones.",
              "Si el usuario no está de acuerdo con estos términos, deberá abstenerse de utilizar la web o la aplicación."
            ]}
          />

          <Section
            number="3"
            title="Registro y cuenta de usuario"
            list={[
              "Ser mayor de edad y contar con capacidad legal para contratar.",
              "Registrar información veraz, actual y completa.",
              "Mantener la confidencialidad de su cuenta y contraseña.",
              "Aceptar expresamente los presentes Términos y Condiciones."
            ]}
            footer="Cualquier uso indebido de la cuenta será responsabilidad del usuario titular. MarketLuz podrá suspender o cancelar cuentas con información falsa o uso fraudulento."
          />

          <Section
            number="4"
            title="Productos y servicios"
            content={[
              "MarketLuz ofrece una plataforma para la comercialización de productos y servicios ofrecidos por vendedores independientes.",
              "Las características, precios y disponibilidad de los productos son responsabilidad del vendedor.",
              "El stock puede variar sin previo aviso y pueden aplicarse restricciones de venta según las políticas del vendedor."
            ]}
          />

          <Section
            number="5"
            title="Precios y formas de pago"
            list={[
              "Los precios se muestran en moneda local (Soles), salvo indicación contraria.",
              "Se aceptan distintos métodos de pago como tarjetas, transferencias y billeteras digitales.",
              "Los precios incluyen o excluyen impuestos según se indique antes de finalizar la compra.",
              "El cliente es responsable de ingresar correctamente sus datos de pago."
            ]}
          />

          <Section
            number="6"
            title="Proceso de compra"
            content={[
              "El proceso de compra incluye la selección del producto, confirmación del pedido y validación del pago.",
              "MarketLuz se reserva el derecho de cancelar pedidos por falta de stock, errores en la información o sospecha de fraude."
            ]}
          />

          <Section
            number="7"
            title="Envíos y entrega"
            content={[
              "La cobertura, costos y tiempos de envío dependen del vendedor y del destino del pedido.",
              "Los plazos de entrega son estimados y pueden verse afectados por causas externas.",
              "Ante retrasos o inconvenientes, el usuario podrá contactar al soporte de MarketLuz."
            ]}
          />

          <Section
            number="8"
            title="Cambios, devoluciones y reembolsos"
            content={[
              "Los cambios, devoluciones y reembolsos se rigen por la Política de Cambios y Devoluciones de MarketLuz.",
              "Dicha política forma parte integrante de los presentes Términos y Condiciones."
            ]}
          />

          <Section
            number="9"
            title="Protección de datos personales"
            content={[
              "MarketLuz cumple con la Ley N° 29733 – Ley de Protección de Datos Personales.",
              "Los datos personales serán utilizados únicamente para la gestión de compras, atención al cliente y mejora del servicio.",
              "El usuario puede ejercer sus derechos ARCO contactando a soporte@marketluz.com."
            ]}
          />

          <Section
            number="10"
            title="Propiedad intelectual"
            content={[
              "Todos los contenidos del sitio web, incluyendo textos, imágenes, logotipos y diseños, están protegidos por derechos de autor.",
              "Queda prohibido el uso no autorizado del contenido de la plataforma."
            ]}
          />

          <Section
            number="11"
            title="Responsabilidad y limitaciones"
            content={[
              "MarketLuz no se responsabiliza por fallas técnicas o interrupciones del servicio.",
              "El uso adecuado de los productos adquiridos es responsabilidad del comprador.",
              "MarketLuz actúa únicamente como intermediario entre vendedores y compradores."
            ]}
          />

          <Section
            number="12"
            title="Legislación aplicable y resolución de conflictos"
            content={[
              "Los presentes Términos y Condiciones se rigen por la legislación peruana.",
              "Cualquier controversia será resuelta mediante conciliación, INDECOPI o las instancias judiciales correspondientes."
            ]}
          />

          <Section
            number="13"
            title="Contacto y soporte"
            content={[
              "📧 Correo electrónico: soporte@marketluz.com",
              "📄 Libro de Reclamaciones Virtual disponible en el sitio web.",
              "🕒 Horario de atención: Lunes a viernes de 8am a 5pm"
            ]}
          />

        </div>
      </div>
    </div>
  );
};

// COMPONENTE SECTION PRO
const Section = ({ number, title, content, list, footer }) => (
  <section className="terminos-section">
    <div className="terminos-section-header">
      <span className="terminos-number">{number}</span>
      <h5>{title}</h5>
    </div>

    {content &&
      content.map((text, i) => (
        <p key={i}>{text}</p>
      ))}

    {list && (
      <ul className="terminos-list">
        {list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )}

    {footer && (
      <p className="terminos-footer">
        <em>{footer}</em>
      </p>
    )}
  </section>
);

export default TerminosCondiciones;
